import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TPostGenerateInvoicePaymentLinkRequest } from "./postGenerateInvoicePaymentLink.schema";

export const postGenerateInvoicePaymentLink = (axios: IAxiosInstance) => {
  return async (params: TPostGenerateInvoicePaymentLinkRequest) => {
    const response = await axios.noRetry.post<IApiResponse<string>>(
      "/api/invoices/payment-link",
      params
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
